"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddKnowledgeArguments = exports.AddKnowledgeOptions = void 0;
exports.AddKnowledgeOptions = [
    {
        name: "knowledge-source",
        type: "string",
        description: "Knowledge source.",
        required: true,
        default: "web-search",
        choices: ["web-search", "oneDrive-sharePoint", "graph-connector", "embedded-knowledge"],
    },
    {
        name: "search-type",
        type: "string",
        description: "Select Search Type",
    },
    {
        name: "web-content",
        type: "string",
        description: "Name of Web Content.",
    },
    {
        name: "teams-manifest-file",
        questionName: "manifest-path",
        type: "string",
        shortName: "t",
        description: "Specify the path for Teams app manifest template. It can be either absolute path or relative path to the project root folder, with default at './appPackage/manifest.json'",
        default: "./appPackage/manifest.json",
    },
    {
        name: "oneDriveSharePointURL",
        type: "string",
        description: "OneDrive or SharePoint Content",
        required: true,
    },
    {
        name: "oneDriveSharePointContent",
        type: "string",
        description: "OneDrive or SharePoint Content",
    },
    {
        name: "graph-connector-content",
        type: "string",
        description: "Graph Connector Content",
        choices: ["inputConnectionId"],
    },
    {
        name: "graph-connector-input",
        type: "string",
        description: "a connection ID for Graph Connector",
    },
    {
        name: "embedded-knowledge-files",
        type: "array",
        description: "Select your embedded knowledge files.",
    },
];
exports.AddKnowledgeArguments = [];
//# sourceMappingURL=AddKnowledgeOptions.js.map